import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormHelperText } from 'components/form-fields';
import { ShowHide } from 'components/layout';
import { NotificationInline } from 'components/notifications';
import { onScreenSignOffMethodKey, SignatureField } from 'pages/employee-reviews/shared';

export const signOffUnaffectedMessage = "These changes do not affect the employee's sign-off.";
const onScreenResignMessage = "The employee must be present to save these changes. They will sign this review again below.";

// The Sign-off step of the edit wizard, offered only when the edit can collect a signature. The
// review's sign-off method is fixed, so once a change resets the sign-off the step takes the
// signatures that calls for: the manager's where the review type requires it, and the employee's
// again, with them present, for a review signed on screen. A change that leaves the signed content
// alone, such as to the driver's triggers, does not touch the sign-off.
export function EditSignOffStep(
    {
        method = null,
        resetsSignOff = false,
        requireManagerSignature = false,
        employeeSignature = null,
        employeeSignedAt = null,
        managerSignature = null,
        managerSignedAt = null,
        loading = false,
        onEmployeeSignatureChange,
        onManagerSignatureChange
    }
) {

    return (
        <div className="form-group">
            <h2>Sign-off</h2>
            <ShowHide
                evaluator={resetsSignOff}
                show={(
                    <Fragment>
                        <FormHelperText loading={loading}>Collect the signatures these changes need before saving.</FormHelperText>
                        <ShowHide
                            evaluator={requireManagerSignature}
                            show={(
                                <SignatureField
                                    id="manager-signature"
                                    headingText="Manager Signature"
                                    signature={managerSignature}
                                    signedAt={managerSignedAt}
                                    loading={loading}
                                    onChange={onManagerSignatureChange}
                                />
                            )}
                        />
                        <ShowHide
                            evaluator={method === onScreenSignOffMethodKey}
                            show={(
                                <Fragment>
                                    <div id="edit-sign-off-notice">
                                        <NotificationInline
                                            allowClose={false}
                                            show
                                            intent="warning"
                                            text={onScreenResignMessage}
                                        />
                                    </div>
                                    <SignatureField
                                        id="employee-signature"
                                        headingText="Employee Signature"
                                        signature={employeeSignature}
                                        signedAt={employeeSignedAt}
                                        loading={loading}
                                        onChange={onEmployeeSignatureChange}
                                    />
                                </Fragment>
                            )}
                        />
                    </Fragment>
                )}
                hide={(
                    <div id="edit-sign-off-notice">
                        <NotificationInline
                            allowClose={false}
                            show
                            intent="primary"
                            text={signOffUnaffectedMessage}
                        />
                    </div>
                )}
            />
        </div>
    );
}

EditSignOffStep.propTypes = {
    method: PropTypes.string,
    resetsSignOff: PropTypes.bool,
    requireManagerSignature: PropTypes.bool,
    employeeSignature: PropTypes.string,
    employeeSignedAt: PropTypes.instanceOf(Date),
    managerSignature: PropTypes.string,
    managerSignedAt: PropTypes.instanceOf(Date),
    loading: PropTypes.bool,
    onEmployeeSignatureChange: PropTypes.func.isRequired,
    onManagerSignatureChange: PropTypes.func.isRequired
};
